export var isMobileBrowser = function isMobileBrowser() {
  return /iP(ad|hone|od)|(Android)/i.test(window.navigator.userAgent);
};
export var isMobileApp = function isMobileApp(userAgent) {
  return userAgent.includes('Android') && userAgent.includes('Version/') || /iP(ad|hone|od)/i.test(userAgent) && !userAgent.includes('Safari');
};